<template>
  <div>
    <template v-if="currentImage && false">
      <div
        class="text-xs-center"
        style="
          height: 120px;
          border-radius: 500px;
          position: relative;
          background-color: rgb(230, 230, 230);
          width: 120px;
          border: 1px solid grey;
          margin-left: auto;
          margin-right: auto;
          overflow: hidden;
          text-align: center;
        "
      >
        <img
          :src="currentImage"
          alt="Upload Product Image"
          style="
            height: 100%;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: -10px;
            object-fit: contain;
            object-position: center;
          "
          :style="{ height: height + 'px' }"
        />
        <div
          style="
            background: #00000036;
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
          "
          :style="{ opacity: showUpload ? 1 : 0 }"
          @mouseover="showUpload = true"
          @mouseleave="showUpload = false"
        >
          <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
            <v-layout justify-center align-center style="height: 100%">
              <v-flex>
                <v-btn dark color="primary" @click="onClickUploadFile()" x-small>{{
                  'Upload'
                }}</v-btn>
                <br />
                <span class="caption">Upload file size: 25MB</span>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="display: flex; align-items: end; justify-content: center">
        <v-btn
          :style="{
            height: '37px',
            width: '100%',
            background: '#0c2f53',
            borderRadius: '5px',
            fontSize: '16px',
            fontWeight: '600',
            color: 'yellow'
          }"
          @click="onClickUploadFile"
        >
          <img
            :src="tray_Arrow_Up"
            alt="Upload"
            style="width: 13px; height: 13px; margin-right: 8px;"
          />
          อัปโหลดไฟล์
        </v-btn>
      </div>

      <div style="color: #bdbdbd; font-weight: 500; font-size: 14px;">
        {{ `(จำนวนไฟล์ที่อัปโหลดแล้ว : ${value ? value.length : 0} ไฟล์ )` }}
      </div>

      <div v-if="showListFile" :class="value ? 'mt-2' : ''">
        <div v-for="(item, i) in value" :key="i">
          <div>
            <div
              color="#eee"
              class=" pb-0"
              :style="removeDisplay ? '' : 'display: flex !important;'"
            >
              <v-card style="border: 0px; box-shadow: none; max-width: 98%;">
                <Typography
                  h6
                  bold
                  fontColor="mediumBlue"
                  :label="` ${decode_utf8(showFilename(item))}`"
                  @click="showItem(item)"
                  class="cursor-pointer pr-2"
                />
              </v-card>

              <img
                class="cursor-pointer "
                :src="imgTrash"
                alt="imgTrash"
                width="20px"
                height="20px"
                @click.stop="!readonly ? deleteItem(i) : ''"
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <ValidationObserver ref="observerdocument" v-slot="{}" tag="form">
      <ValidationProvider :name="'profile'" :rules="'size:25600'" v-slot="{}">
        <input
          type="file"
          :multiple="multiple"
          v-show="false"
          ref="inputUploadDocument"
          class="form-control-file pt-2"
          name="photoUploadDocument"
          id="photoUploadInputDocument"
          data-vv-as="File"
          :key="`upload_${uploadtimestamp}`"
          @change="onFileChange($event)"
          style="
            overflow: hidden;
            position: fixed;
            width: 1px;
            height: 1px;
            z-index: -1;
            opacity: 0;
          "
        />
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import config from '@/config'
import api from '@/api'
import axios from 'axios'
import moment from 'moment'
import Typography from '@/components/elements/Typography.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  props: {
    multiple: false,
    readonly: {
      default: false
    },
    value: null,
    height: {
      default: 100,
      type: Number
    },
    errors: {
      default: () => [],
      type: Array
    },

    showListFile: {
      default: false,
      type: Boolean
    },
    text: {
      default: 'อัปโหลดไฟล์',
      type: String
    },
    width: {
      type: String,
      default: '180'
    },
    removeDisplay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Typography
  },
  mounted() {
    console.log('Hello upload')
  },
  data: function() {
    return {
      showUpload: false,
      currentImage: this.value,
      currentImageName: null,
      isAlert: false,
      loading: false,
      uploadtimestamp: moment().format('x'),
      imgTrash: require('@/assets/image/trash.png'),
      tray_Arrow_Up: require('@/assets/image/tray-arrow-up.png')
    }
  },

  computed: {
    currentImageNameJoined() {
      if (this.multiple && this.currentImageName) {
        if (this.currentImageName.length > 1) {
          return this.currentImageName.length + ' files'
        } else {
          return this.currentImageName
        }
      } else {
        return this.currentImageName
      }
    },

    currentNameJoined() {
      if (this.multiple && this.value) {
        if (this.value.length > 1) {
          // return this.value.length + "";
        } else {
          // return typeof this.value === "object"
          //   ? this.showFilename(this.value[0])
          //   : this.value;
        }
      } else if (this.value) {
        if (this.value.length > 1) {
          this.deleteItem(0)
        }
        // return typeof this.value == "object" && this.value != null
        //   ? this.showFilename(this.value[0])
        //   : this.value;
      }
    }
  },
  methods: {
    decode_utf8(s) {
      return decodeURIComponent(s)
    },

    deleteItem(index) {
      if (this.currentImageName) {
        this.currentImageName.splice(index, 1)
        if (this.currentImageName.length == 0) {
          this.currentImage = ''
        }
      }

      this.value.splice(index, 1)
      this.$emit('input', this.value)
    },

    showFilename(value) {
      // console.log(value);
      let result = value

      if (result) {
        result = result.split('/')

        var newdata = result[5]
        result = newdata.substring(14)
      }
      return result
    },

    showItem(item) {
      this.$liff.openWindow({
        url: item,
        external: true
      })
    },
    deleteAllFiles() {
      if (!this.readonly) {
        this.currentImageName = ''
        this.currentImage = ''
      }
    },
    onClickUploadFile() {
      var vm = this

      if (!this.readonly) {
        vm.uploadtimestamp = moment().format('x')
        vm.$nextTick(() => {
          vm.$refs.inputUploadDocument.click()
        })
      }
    },
    onClickUploadBtn() {
      document.getElementById('photoUploadInputDocument').click()
    },
    fileResize: function(file, callback) {
      let vm = this
      var reader = new FileReader()
      reader.onloadend = function() {
        var tempImg = new Image()
        tempImg.src = reader.result
        tempImg.onload = function() {
          var MAX_WIDTH = 1000
          var MAX_HEIGHT = 1000
          var tempW = tempImg.width
          var tempH = tempImg.height
          if (tempW > tempH) {
            if (tempW > MAX_WIDTH) {
              tempH *= MAX_WIDTH / tempW
              tempW = MAX_WIDTH
            }
          } else {
            if (tempH > MAX_HEIGHT) {
              tempW *= MAX_HEIGHT / tempH
              tempH = MAX_HEIGHT
            }
          }

          var canvas = document.createElement('canvas')
          canvas.width = tempW
          canvas.height = tempH
          var ctx = canvas.getContext('2d')
          ctx.drawImage(this, 0, 0, tempW, tempH)
          var dataURL = canvas.toDataURL('image/jpeg')
          var data = 'image=' + dataURL
          var obj = vm.dataURItoBlob(data)
          obj.name = file.name
          callback(obj)
        }
      }
      reader.readAsDataURL(file)
    },
    dataURItoBlob: function(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function(event) {
      this.isAlert = false
      let vm = this
      var isValid = await this.$refs.observerdocument.validate()

      if (!isValid) {
        vm.uploadtimestamp = moment().format('x')
        return false
      }
      let files = event.target.files || event.dataTransfer.files
      var isAllImage = true

      if (isAllImage) {
        if (!files.length) {
          vm.uploadtimestamp = moment().format('x')
          return
        }
        // vm.fileResize(files[0], function(obj) {});
        for (let file of files) {
          // vm.fileResize(file, function(obj) {
          //   });
          if (file.type == 'image/png' || file.type == 'image/jpeg') {
            vm.fileResize(file, function(obj) {
              ''
              vm.createImage(file)
            })
          } else {
            vm.createImage(file)
          }
        }

        event.target.value = ''
      }
    },
    createImage(file) {
      // let reader = new FileReader();
      let vm = this
      vm.upload(file)
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function(error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          if (vm.currentImage) {
            vm.currentImage.push(url)
          } else {
            vm.currentImage = []
            vm.currentImage.push(url)
          }
          vm.loading = false
          vm.$emit('input', vm.currentImage)
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve()
        })
      })
    },
    uploadfile: function(data, callback) {
      let signedRequest = data.signedRequest
      let request = data.file
      const xhr = new XMLHttpRequest()
      xhr.open('PUT', signedRequest)
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            callback()
          } else {
            alert('Could not upload file.')
          }
        }
      }
      xhr.send(request)
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.currentImage = value
        // console.log({ value });
        if (this.multiple && this.value) {
          return
        } else if (this.value) {
          if (this.value.length > 1) {
            this.deleteItem(0)
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/projectMaster/AddMemberForm/UploadDocument.vue